import React, { useState, useEffect } from 'react';
import { Button, Input } from "reactstrap";
import { CspModal, CspModalHeader, CspModalBody, CspModalFooter } from "../CspModal";

const CommentModal = ({ open, toggle, onSubmit }) => {
    const [comment, setComment] = useState('');

    useEffect(() => {
        if (open) {
            setComment(''); // Reset comment when modal opens
        }
    }, [open]);

    const handleSubmit = () => {
        if (comment.trim()) {
            onSubmit(comment);
            setComment('');
        }
    };

    const handleClose = () => {
        setComment('');
        toggle();
    };

    return (
        <CspModal open={open} toggle={handleClose} size="md">
            <CspModalHeader title="Add Comment" toggle={handleClose} />
            <CspModalBody>
                <div className="mb-3">
                    <p>Add a comment so that the CS can update the product ticket accordingly</p>
                </div>
                <div className="mb-3">
                    <Input
                        type="textarea"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Enter your comment..."
                        rows="4"
                        style={{ width: '100%' }}
                    />
                </div>
            </CspModalBody>
            <CspModalFooter>
                <Button color="secondary" onClick={handleClose} className="mr-2">
                    Cancel
                </Button>
                <Button 
                    color="primary" 
                    onClick={handleSubmit}
                    disabled={!comment.trim()}
                >
                    Update & Notify CS
                </Button>
            </CspModalFooter>
        </CspModal>
    );
};

export default CommentModal;
